import request from '@/utils/request';
//获取活动模板列表数据
export const getTemplateData = (data) => {
    return request({ url: '', method: 'POST', data });
};
/**
 * 查询活动班级列表请求地址
 */
// export const getClazzList = (data) => {
//     return request({
//         url: '/teacher/mental/activity/clazzList.vpage',
//         method: 'post',
//         data,
//     });
// };
/**
 * 查询活动班级列表请求地址
 */
export const getClazzList = (data) => {
    return request({
        url: '/teacher/mental/activity/getClazzList.vpage',
        method: 'post',
        data,
    });
};
/**
 * 提醒学生参赛
 */
export const remindJoin = (params) => {
    return request({
        url: '/teacher/mental/activity/remindjoin.vpage',
        method: 'get',
        params,
    });
};
/**
 * 获取默认教材
 */
export const getBook = (params) => {
    return request({
        url: '/teacher/new/homework/clazz/book.vpage',
        method: 'get',
        params,
    });
};
/**
 * 根据年级上下册获取教材
 */
export const getSortBook = (params) => {
    return request({
        url: '/teacher/new/homework/sortbook.vpage',
        method: 'get',
        params,
    });
};
/**
 * 更换默认教材
 */
export const changeBook = (data) => {
    return request({
        url: '/teacher/new/homework/changebook.api',
        method: 'post',
        data,
    });
};
/**
 * 获取学科及对应的活动类型
 */
export const getSubjectActivityType = (params) => {
    return request({
        url: '/teacher/mental/activity/getSubjectActivityType.vpage',
        method: 'get',
        params,
    });
};
/**
 * 获取推荐活动模板列表
 */
export const recommendTemplateList = (params) => {
    return request({
        url: '/teacher/mental/activity/recommendTemplateList.vpage',
        method: 'get',
        params,
    });
};
/**
 * 获取推荐活动模板列表（普通模板向上拉分页加载）
 */
export const recommendTemplateListPage = (params) => {
    return request({
        url: '/teacher/mental/activity/recommendTemplateListPage.vpage',
        method: 'get',
        params,
    });
};
/**
 * 获取推荐活动模板内容
 */
export const recommendTemplateDetail = (params) => {
    return request({
        url: '/teacher/mental/activity/recommendTemplateDetail.vpage',
        method: 'get',
        params,
    });
};
/**
 * 查知识点
 */
export const loadMentalKnowledgePoint = (params) => {
    return request({
        url: '/teacher/mental/activity/loadMentalKnowledgePoint.vpage',
        method: 'get',
        params,
    });
};
/**
 * 查询古诗、配音列表上的筛选项
 */
export const getTopicLabel = (params) => {
    return request({
        url: '/teacher/mental/activity/topicLabel.vpage',
        method: 'get',
        params,
    });
};
/**
 * 查询古诗列表
 */
export const searchAncientPoetryMissionList = (params) => {
    return request({
        url: '/teacher/mental/activity/searchAncientPoetryMissionList.vpage',
        method: 'get',
        params,
    });
};
/**
 * 查询朗读列表
 */
export const searchReadReciteList = (params) => {
    return request({
        url: '/teacher/mental/activity/searchReadReciteList.vpage',
        method: 'get',
        params,
    });
};
/**
 * 查询趣味配音列表
 */
export const searchDubbingList = (data) => {
    return request({
        url: '/teacher/mental/activity/dubbing/search.vpage',
        method: 'post',
        data,
    });
};
/**
 * 通过模板生成活动
 */
export const createActivityByTemplate = (data) => {
    return request({
        url: '/teacher/mental/activity/createActivityByTemplate.vpage',
        method: 'post',
        data,
    });
};
/**
 * 个性化定制根据活动类型获取数据
 */
export const readyCustomData = (params) => {
    return request({
        url: '/teacher/mental/activity/readyCustomData.vpage',
        method: 'get',
        params,
    });
};
/**
 * 个性化定制活动布置前预览数据
 */
export const reviewActivityByCustom = (data) => {
    return request({
        url: '/teacher/mental/activity/reviewActivityByCustom.vpage',
        method: 'post',
        data,
    });
};
/**
 * 个性化定制活动提交数据
 */
export const createActivityByCustom = (data) => {
    return request({
        url: '/teacher/mental/activity/createActivityByCustom.vpage',
        method: 'post',
        data,
    });
};
/**
 * 客服定制活动提交数据
 */
export const specialActivity = (data) => {
    return request({
        url: '/teacher/mental/activity/specialActivity.vpage',
        method: 'post',
        data,
    });
};
/**
 * 获取所有活动报告
 */
export const getActivityReport = (params) => {
    return request({
        url: '/teacher/mental/activity/getAllActivity.vpage',
        method: 'get',
        params,
    });
};
